//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiButton from "../button/Index.vue";
import { DEVICE } from "../../store/mutation-types";
import store from "../../store/index";

export default {
  name: "MulConfirmComponent",
  components: { HiButton },
  computed: {
    isIos() {
      return store.getters[DEVICE] === "ios";
    },
  },
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    // 标题
    title: {
      type: String,
    },
    // 中间文案
    text: {
      type: String,
      default: "",
    },
    // 是否显示已做v-model
    show: {
      type: Boolean,
      default: false,
    },
    buttons: {
      type: Array,
      default: [],
    },
    cancelText: {
      type: String,
      default() {
        return this.$t("common.cancel");
      },
    },
  },
  data() {
    return {
      showModal: this.show,
      inputVal: "",
    };
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
      if (val) {
        this.inputVal = "";
      }
    },
    show(val) {
      this.showModal = val;
    },
  },
  methods: {
    /**
     * 取消按钮点击事件
     */
    async cancelClick() {
      this.showModal = false;
    },
    /**
     * 确定按钮点击事件
     */
    async itemClick(click) {
      const success = await await click();
      if (success) {
        this.showModal = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/confirm/Mul.vue